export const MORE_VIDEOS_PLUGIN_MORE_VIDEOS_TEXT = 'More Videos';

export const MORE_VIDEOS_SHOW_GALLERY_PLAYLIST_VIEW_SECONDS_TO_END = 5;

export const GALLERY_VIDEO_PLACEHOLDER_LARGE_WIDTH = 132;
export const GALLERY_VIDEO_PLACEHOLDER_EXTRA_LARGE_WIDTH = 169;
export const GALLERY_VIDEO_LARGE_MARGINS_LEFT = 12;
export const GALLERY_VIDEO_EXTRA_LARGE_MARGINS_LEFT = 16;
